"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = exports.composeRequestInput = exports.resolveHeadersFromSomeFetchApi = exports.cleanseRequestPath = exports.cleanseRequestHostname = void 0;
const header_1 = require("@matt-usurp/grok/http/header");
const qs_1 = require("qs");
const header_2 = require("../authentication/header");
const number_1 = require("../data/number");
const header_3 = require("./header");
const REGEX_SLASH_LEADING = /^\//;
const REGEX_SLASH_TRAILING = /\/$/;
const cleanseRequestHostname = (value) => {
    return value.replace(REGEX_SLASH_TRAILING, '');
};
exports.cleanseRequestHostname = cleanseRequestHostname;
const cleanseRequestPath = (value) => {
    return value
        .replace(REGEX_SLASH_LEADING, '')
        .replace(REGEX_SLASH_TRAILING, '');
};
exports.cleanseRequestPath = cleanseRequestPath;
/**
 * Resolve the {@link HttpHeaders} from the given {@link value} which represents the headers key from some fetch api.
 * This is required because `node-fetch` and browser `fetch` have different `response.headers` types.
 * The browser uses a regular `Record<string, string>` and the `node-fetch` api uses a complex class.
 */
const resolveHeadersFromSomeFetchApi = (value) => {
    if (value === undefined || value === null) {
        return {};
    }
    // The `node-fetch` headers type that is for some reason a pain.
    if (value.forEach !== undefined) {
        const headers = {};
        // Seemingly the only way to retrieve all the headers.
        // Actually madness.
        value.forEach((value, key) => {
            headers[key] = value;
        });
        return headers;
    }
    return value;
};
exports.resolveHeadersFromSomeFetchApi = resolveHeadersFromSomeFetchApi;
/**
 * Compose the given {@link input} into {@link ClientRequestInputComposed}.
 */
const composeRequestInput = (input) => {
    const hostname = (0, exports.cleanseRequestHostname)(input.hostname);
    const path = (0, exports.cleanseRequestPath)(input.path);
    let url = `${hostname}/${path}`;
    if (input.query !== undefined) {
        const params = (0, qs_1.stringify)(input.query, {
            encode: true,
            encodeValuesOnly: true,
            allowDots: true,
            arrayFormat: 'brackets',
        });
        url = `${url}?${params}`;
    }
    const headers = {
        ...(0, header_1.ensureHttpHeaderMapping)(input.headers),
        'accept': 'application/json',
    };
    if (input.credentials !== undefined) {
        const value = (0, header_2.composeTokensForHeaderValue)(input.credentials);
        if (value !== undefined) {
            headers['authorization'] = value;
        }
    }
    // If we have a payload we should be good citizens and send the expected content type headers.
    // In this case we only support a single content type so this works for now.
    if (input.payload !== undefined) {
        headers['content-type'] = 'application/json';
    }
    return {
        method: input.method.toUpperCase(),
        url,
        headers,
        body: JSON.stringify(input.payload),
    };
};
exports.composeRequestInput = composeRequestInput;
/**
 * A client factory that works with the `fetch` api.
 *
 * This produces a {@link Client} that can be used with any of the endpoint functions.
 */
const factory = (api) => {
    return async (input) => {
        const request = (0, exports.composeRequestInput)(input);
        const response = await api(request.url, {
            method: request.method,
            headers: request.headers,
            body: request.body,
            // Attach the signal if provided, the types mis-match at the moment so just forcing them.
            // In any case this should be a build safe cast.
            signal: input.signal,
        });
        const headers = (0, exports.resolveHeadersFromSomeFetchApi)(response.headers);
        const length = (0, number_1.parseIntegerFromString)((0, header_3.getContentLengthHeader)(headers), 0);
        let body = undefined;
        if (length > 0) {
            body = await response.json();
        }
        return {
            status: response.status,
            headers,
            body,
        };
    };
};
exports.factory = factory;
